import PageHeader from "components/PageHeader";
import Spinner from "components/Spinner";
import Info from "./components/Info";
import "./index.scss";
import useDetail from "./useDetail";

function ContractDetail() {
  const { contractDetail, loading, refetch } = useDetail();

  return (
    <div className="wrapper">
      <Spinner loading={loading} />
      <PageHeader
        pageTitle="Xem chi tiết hợp đồng"
        routes={[
          { path: "#", name: "Đại lý" },
          { path: "/list-contract", name: "Hợp đồng" },
          {
            path: "",
            name: "Xem chi tiết hợp đồng",
          },
        ]}
      />

      <Info dataDetail={contractDetail} refetch={refetch} />
    </div>
  );
}

export default ContractDetail;
